import * as Yup from 'yup'

export const schemaProductList = (t: (key: string) => string) => ({
  items: Yup.array()
    .min(1, t('requiredMessage'))
    .required(t('requiredMessage')),
})
